import React, { FC, Fragment, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import { Organization } from 'models/organization';
import { useTranslation } from 'react-i18next';
import NShiftClinicSelect from './nshift-clinic-select.component';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

type PackagesWithoutOrdersDialogProps = {
    currentClinic: Organization | undefined;
    open: boolean;
    onClose: () => void;
    onAddPackages: (clinic: Organization, noOfPackages: number) => void;
};
const PackagesWithoutOrdersDialog: FC<PackagesWithoutOrdersDialogProps> = ({
    open,
    onClose,
    currentClinic,
    onAddPackages,
}: PackagesWithoutOrdersDialogProps) => {
    const { t: translate } = useTranslation(['transport']);
    const [noOfManualPackages, setNoOfManualPackages] = useState(1);
    const [selectedClinic, setSelectedClinic] = useState<Organization | undefined>(currentClinic);

    const handleAddPackages = () => {
        if (selectedClinic) {
            onAddPackages(selectedClinic as Organization, noOfManualPackages);
        }
    };

    useEffect(() => {
        setNoOfManualPackages(1);
        open ? setSelectedClinic(currentClinic) : setSelectedClinic(undefined);
    }, [open]);

    const handleClinicChange = (_: React.SyntheticEvent, clinic: Organization | null) => {
        if (clinic) {
            setSelectedClinic(clinic);
        }
    };

    return (
        <Fragment>
            <DHDialog
                title={translate('transport:ADD_PACKAGE_WITHOUT_ORDER')}
                maxWidth="sm"
                fullWidth
                open={open}
                onClose={onClose}
                actions={
                    <Fragment>
                        <Button
                            variant="contained"
                            onClick={() => handleAddPackages()}
                            disabled={!selectedClinic || noOfManualPackages < 1}
                        >
                            {translate('transport:ADD_PACKAGES')}
                        </Button>
                    </Fragment>
                }
            >
                <Box mt={1}>
                    {!currentClinic ? (
                        <Box mb={2}>
                            <NShiftClinicSelect
                                selectedClinic={selectedClinic}
                                onClinicFilterChange={handleClinicChange}
                            />
                        </Box>
                    ) : undefined}
                    <FormControl fullWidth>
                        <InputLabel id="no-of-packages-label">{translate('transport:NUMBER_OF_PACKAGES')}</InputLabel>
                        <Select
                            labelId="no-of-packages-label"
                            value={noOfManualPackages}
                            label={translate('transport:NUMBER_OF_PACKAGES')}
                            onChange={(e) => setNoOfManualPackages(parseInt(e.target.value as string))}
                        >
                            {Array.from(Array(20).keys()).map((value) => (
                                <MenuItem key={value + 1} value={value + 1}>
                                    {value + 1}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DHDialog>
        </Fragment>
    );
};

export default PackagesWithoutOrdersDialog;
